class LoaderService {
  constructor() {
    this.loaderElement = null; // Reference to the loader element
    this.skipCount = 0;
  }

  setLoaderElement(loaderElement) {
    this.loaderElement = loaderElement;
  }

  skipRequests(count = 1) {
    this.skipCount += count;
  }

  showLoader() {
    if (this.skipCount > 0) {
      this.skipCount--;
      return;
    }

    if (this.loaderElement) {
      this.loaderElement.style.display = "block";
    }
  }

  // Method to hide the loader
  hideLoader() {
    if (this.loaderElement) {
      this.loaderElement.style.display = "none"; // Hide the loader element
    }
  }
}

const loaderService = new LoaderService();

export default loaderService;
